module.exports = __webpack_public_path__ + "static/media/chewacca.2270db3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/chewacca.jpg
// module id = 38
// module chunks = 0